import { useContext } from "react";
import { SharedIdentityContext } from "./SharedIdentityContext";

const useSharedIdentity = () => useContext(SharedIdentityContext);

export default useSharedIdentity;
